"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Indicator = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Indicator = exports.Indicator = _styledComponents["default"].span.withConfig({
  displayName: "Indicator",
  componentId: "sc-acu4qz-0"
})(["background:", ";border-radius:inherit;block-size:12px;position:absolute;top:2px;inline-size:12px;"], (0, _index.cssColorValue)(_index.semanticColors.backgroundBase));